import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { queryClient as browserQueryClient } from "./lib/queryClient";

export const getRouter = () => {
  // Browser: reuse the app-wide singleton (non-React modules like userRoleCache
  // read/invalidate the same cache). Server: a fresh cache per request so no
  // data leaks between concurrent SSR requests. Defaults ported from
  // src/lib/queryClient.ts.
  const queryClient =
    typeof window === "undefined"
      ? new QueryClient({
          defaultOptions: {
            queries: {
              staleTime: 5 * 60 * 1000,
              refetchOnWindowFocus: false,
            },
          },
        })
      : browserQueryClient;

  const router = createRouter({
    routeTree,
    context: { queryClient },
    // Route scroll resets are handled by ScrollToTop after genuine pathname
    // changes. Router restoration can commit late during hydration and send a
    // visitor who has already started scrolling back to the landing hero.
    scrollRestoration: () => false,
    defaultPreloadStaleTime: 0,
    // Warm route loaders on hover/touch so a click does not wait on them, and
    // keep the current page on screen for a moment instead of flashing a
    // pending state on fast transitions.
    defaultPreload: "intent",
    defaultPreloadDelay: 50,
    defaultPendingMs: 400,
    defaultPendingMinMs: 300,
  });

  return router;
};
